import { Program, ProgramAdditionalInformation } from '../../../types/program';

export const formatVisualStepValues = (program: Program) => {
  const defaultInfo: ProgramAdditionalInformation = {
    id: 0,
    name: '',
    description: '',
    activated: true,
    order: 0,
    type: '',
  };

  const howItWorksInfo =
    program.additionalInformation.find(info => info.order === 1) || defaultInfo;
  const whoHelpYouInfo =
    program.additionalInformation.find(info => info.order === 2) || defaultInfo;

  const formatImage = (image: string | null) => ({
    preview: image || '',
    name: '',
    file: '',
  });

  return {
    thumb: {
      web: {
        neutral: formatImage(program.images.thumb.web.neutral),
        female: formatImage(program.images.thumb.web.female),
        male: formatImage(program.images.thumb.web.male),
      },
      mobile: {
        neutral: formatImage(program.images.thumb.mobile.neutral),
        female: formatImage(program.images.thumb.mobile.female),
        male: formatImage(program.images.thumb.mobile.male),
      },
      tv: {
        neutral: formatImage(program.images.thumb.tv.neutral),
        female: formatImage(program.images.thumb.tv.female),
        male: formatImage(program.images.thumb.tv.male),
      },
    },
    teaser: program.teaser,
    logotipo: {
      neutral: formatImage(program.images.logotipo.neutral),
      female: formatImage(program.images.logotipo.female),
      male: formatImage(program.images.logotipo.male),
    },
    bannerInterno: {
      web: {
        neutral: formatImage(program.images.bannerInterno?.web?.neutral),
        female: formatImage(program.images.bannerInterno?.web?.female),
        male: formatImage(program.images.bannerInterno?.web?.male),
      },
      tv: {
        neutral: formatImage(program.images.bannerInterno?.tv?.neutral),
        female: formatImage(program.images.bannerInterno?.tv?.female),
        male: formatImage(program.images.bannerInterno?.tv?.male),
      },
      mobileApp: {
        neutral: formatImage(program.images.bannerInterno.mobileApp.neutral),
        female: formatImage(program.images.bannerInterno.mobileApp.female),
        male: formatImage(program.images.bannerInterno.mobileApp.male),
      },
      tablet: {
        neutral: formatImage(program.images.bannerInterno.tablet.neutral),
        female: formatImage(program.images.bannerInterno.tablet.female),
        male: formatImage(program.images.bannerInterno.tablet.male),
      },
    },
    bannerQuiz: {
      web: {
        neutral: formatImage(program.images.bannerQuiz.web.neutral),
        female: formatImage(program.images.bannerQuiz.web.female),
        male: formatImage(program.images.bannerQuiz.web.male),
      },
      appResponsive: {
        neutral: formatImage(program.images.bannerQuiz.appResponsive.neutral),
        female: formatImage(program.images.bannerQuiz.appResponsive.female),
        male: formatImage(program.images.bannerQuiz.appResponsive.male),
      },
    },
    whoHelpYou: {
      name: whoHelpYouInfo.name || 'Quem vai te ajudar',
      description: whoHelpYouInfo.description || '',
      activated: whoHelpYouInfo.activated ?? true,
    },
    howItWorks: {
      name: howItWorksInfo.name || 'Como funciona',
      description: howItWorksInfo.description || '',
      activated: howItWorksInfo.activated ?? true,
    },
  };
};
